export const DENTOLO_THEME = 'f8-theme-v1';
export const PETOLO_THEME = 'petolo-theme';
export const VITOLO_THEME = 'vitolo-theme';
export const DA_DIREKT_THEME = 'da-direkt';
export const DA_KAUFLAND_THEME = 'da-kaufland-theme';
export const FRESSNAPF_THEME = 'fressnapf-theme';
export const DENTOLO_LEFT_ALIGN_THEME = 'dentolo-left-align-theme';

export const THEME = {
  DENTOLO_THEME,
  PETOLO_THEME,
  VITOLO_THEME,
  DA_DIREKT_THEME,
  DA_KAUFLAND_THEME,
  FRESSNAPF_THEME,
  DENTOLO_LEFT_ALIGN_THEME,
};
